export default [
  {
    path: 'vocational-evaluation',
    component: () =>
      import('@/views/provider/vocational-evaluation/Wrapper.vue'),
    children: [
      {
        path:
          '/provider/AppointmentManagement/:appointmentId/vocational-evaluation/:id?',
        name: 'vocationalEvaluation',
        props: true,
        component: () =>
          import('@/views/provider/vocational-evaluation/Main.vue'),
      },
      {
        path:
          '/provider/AppointmentManagement/vocational-evaluation/instrument/:id',
        name: 'InstrumentDetail',
        props: true,
        component: () =>
          import(
            '@/views/provider/vocational-evaluation/tabs/five/instrument/Main.vue'
          ),
      },
    ],
  },
];
